module.exports = __webpack_public_path__ + "img/wossnewlogo2.5f2397a4.png";